// extracted by css-extract-rspack-plugin
export default {"indicator":"mKiSvNAXSJ8UVSNa"};